import { palette } from "@dd/ui-tokens";
import { Shell } from "./shell/Shell";
import { WMDemo } from "./wm/WMDemo";

/**
 * F0-T06: App monta la shell ArgOS (boot → login → desktop).
 * Rutas de inspección: ?tokens (página de T02) y ?wmdemo (demo de T05).
 */
export function App() {
  const params = new URLSearchParams(window.location.search);
  if (params.has("tokens")) return <TokensPage />;
  if (params.has("wmdemo")) return <WMDemo />;
  return <Shell />;
}

/** Página de prueba de tokens (F0-T02) — validación visual contra estetica §1. */

const swatches = Object.entries(palette) as [keyof typeof palette, string][];

function TokensPage() {
  return (
    <main style={{ padding: "var(--space-6)", maxWidth: 960, margin: "0 auto" }}>
      <h1
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 400,
          fontSize: 44,
          color: "var(--laton)",
          margin: 0,
        }}
      >
        ArgOS
      </h1>
      <p style={{ color: "var(--humo)", marginTop: "var(--space-1)" }}>
        Archive &amp; Records General Operating System — prueba de tokens
      </p>

      <section style={{ display: "flex", gap: "var(--space-2)", flexWrap: "wrap" }}>
        {swatches.map(([name, cssVar]) => (
          <figure key={name} style={{ margin: 0, textAlign: "center" }}>
            <div
              style={{
                width: 96,
                height: 64,
                background: cssVar,
                border: "1px solid var(--humo)",
                borderRadius: "var(--radius-2)",
              }}
            />
            <figcaption
              style={{ fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--humo)" }}
            >
              {name}
            </figcaption>
          </figure>
        ))}
      </section>

      <section
        style={{
          marginTop: "var(--space-6)",
          background: "var(--papel)",
          color: "var(--tinta)",
          padding: "var(--space-5)",
          borderRadius: "var(--radius-2)",
          lineHeight: "var(--leading-reading)",
        }}
      >
        <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 400, marginTop: 0 }}>
          El testamento de Bellamira
        </h2>
        <p>
          La señora Ondina Bellamira firmó su último testamento un jueves de niebla. El viernes
          apareció flotando en la dársena del club náutico. La familia dice accidente; la
          aseguradora dice que primero verifiquemos. Ahí entrás vos.
        </p>
        <p style={{ fontWeight: 600 }}>
          Peso 600 de Public Sans para énfasis en UI — áéíóúñ ÁÉÍÓÚÑ.
        </p>
        <p style={{ fontFamily: "var(--font-mono)", fontSize: 13 }}>
          2011-03-17 22:41 · REG-4471 · llamada saliente 4 min 12 s — IBM Plex Mono
        </p>
        <p>
          <span style={{ color: "var(--carmin)", fontWeight: 600 }}>El crimen es carmín</span>
          {" · "}
          <span style={{ color: "var(--billar)", fontWeight: 600 }}>la verdad es billar</span>
          {" · "}
          <span style={{ color: "var(--laton)", fontWeight: 600 }}>el sistema es latón</span>
        </p>
      </section>
    </main>
  );
}
